import { Messages } from '../../../../codegen/Localize';
import { IDataAlertInfo } from '../../../../ts/models/IDataAlertInfo';
import { dataAlertEdit } from '../../../actions/spaces/DataAlertMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isAlertSuspended, isEditOrResumeEnabled } from './IEntityActionHelpers';

export const DataAlertEditAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editDataAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return !isAlertSuspended(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[], state: AppState) => {
    return isEditOrResumeEnabled(state, targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertEdit(targetItems)
};
